import React from 'react';

/**
 * SPOT 코인 아이콘 컴포넌트 (금색 S 아이콘)
 * @param {number} size - 아이콘 크기 (기본값: 20)
 * @param {number} width - 아이콘 너비 (size 우선, 없으면 width 사용)
 * @param {number} height - 아이콘 높이 (size 우선, 없으면 height 사용)
 * @param {string} color - 아이콘 색상 (기본값: #FFD700 - 금색)
 */
const SpotCoinIcon = ({ size, width, height, color = '#FFD700' }) => {
    const iconSize = size || width || height || 20;
    const iconWidth = size || width || 20;
    const iconHeight = size || height || 20;
    
    return (
        <svg
            width={iconWidth}
            height={iconHeight}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            {/* Outer glow circle */}
            <circle cx="12" cy="12" r="10" fill={color} opacity="0.2" />
            {/* Main coin */}
            <circle cx="12" cy="12" r="8" fill={color} />
            {/* S symbol */}
            <path
                d="M12 6C10.5 6 9.5 6.5 9 7.5C8.5 8.5 8.5 9.5 9 10.5C9.5 11.5 10.5 12 12 12C13.5 12 14.5 12.5 15 13.5C15.5 14.5 15.5 15.5 15 16.5C14.5 17.5 13.5 18 12 18"
                stroke="white"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                fill="none"
            />
        </svg>
    );
};

export default SpotCoinIcon;
